import { useQuery } from '@tanstack/react-query';

import type { ProductivitySummary } from '@cobliteam/common-types';

import {
  ProductivityRequester,
  type ProductivitySummaryRequest,
  type ProductivityTimeSeriesChartRequest,
  type TimeseriesChart,
} from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const productivityRequester = new ProductivityRequester({ host: env.apiHost });
const DRIVER_QUERY_KEY = 'DRIVER_PRODUCTIVITY';
const VEHICLE_QUERY_KEY = 'VEHICLE_PRODUCTIVITY';
const PRODUCTIVITY_CHART_QUERY_KEY = 'PRODUCTIVITY_CHART';

const useProductivity = () => {
  const getVehicleProductivitySummary = (request: ProductivitySummaryRequest) =>
    useQuery<ProductivitySummary>({
      queryKey: [`${VEHICLE_QUERY_KEY}_SUMMARY`, JSON.stringify(request)],
      queryFn: () =>
        productivityRequester.getVehicleProductivitySummary(request),
      staleTime: 300000,
    });

  const getDriverProductivitySummary = (request: ProductivitySummaryRequest) =>
    useQuery<ProductivitySummary>({
      queryKey: [`${DRIVER_QUERY_KEY}_SUMMARY`, JSON.stringify(request)],
      queryFn: () =>
        productivityRequester.getDriverProductivitySummary(request),
      staleTime: 300000,
    });

  const getTimeSeriesChart = (
    request: ProductivityTimeSeriesChartRequest,
    enabled = true
  ) =>
    useQuery<TimeseriesChart[]>({
      queryKey: [PRODUCTIVITY_CHART_QUERY_KEY, JSON.stringify(request)],
      queryFn: () =>
        productivityRequester.getProductivityTimeSeriesChart(request),
      retry: false,
      enabled: enabled,
    });

  return {
    getVehicleProductivitySummary,
    getDriverProductivitySummary,
    getTimeSeriesChart,
  };
};
export default useProductivity;
